/**
 * FILE: packages/supabase/src/installments/reads.ts
 * PURPOSE: Installment plan read operations.
 */

import type { DbClient } from '../dbClient'
import { defaultDbClient } from '../dbClient'
import type { Installment } from './dto'

function toInstallment(row: Record<string, unknown>): Installment {
  return {
    id: row.id as string,
    phone: row.phone as string,
    enrollmentId: (row.enrollment_id as string | null) ?? null,
    amount: Number(row.amount ?? 0),
    paidAmount: Number(row.paid_amount ?? 0),
    dueDate: row.due_date as string,
    paidAt: (row.paid_at as string | null) ?? null,
    status: row.status as Installment['status'],
    notes: (row.notes as string | null) ?? null,
    createdAt: (row.created_at as string | null) ?? null,
    updatedAt: (row.updated_at as string | null) ?? null,
  }
}

export async function getInstallmentsByPhone(
  phone: string,
  client: DbClient = defaultDbClient
): Promise<Installment[]> {
  const { data, error } = await client
    .from('installments')
    .select('id, phone, enrollment_id, amount, paid_amount, due_date, paid_at, status, notes, created_at, updated_at')
    .eq('phone', phone)
    .is('deleted_at', null)
    .order('due_date', { ascending: true })

  if (error) throw error
  return (data ?? []).map((row) => toInstallment(row as Record<string, unknown>))
}
